import { useContext } from 'react';

import { useQuery } from 'react-query';

import { ClientError } from '../../api';
import { ApiContext, CoreContext } from '../../providers';
import { addUserData, setError } from '../../state';

export const useScoreQuery = () => {
    const { Upscore } = useContext(ApiContext);
    const { store, settings } = useContext(CoreContext);

    return useQuery('score', () => Upscore.getUserScoredata(), {
        onSuccess: (data) => {
            store.dispatch(addUserData('scoreData', data.scoreData));
        },
        onError: (error: any) => {
            store.dispatch(setError('general'));
            throw new ClientError(error.message, {
                category: 'Upscore API',
                type: 'general',
                error,
            });
        },
    });
};
